// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2fdxa","content":"Consent_content__ilvB9","footer":"Consent_footer__3JBQU"};